import DealsSection from "./DealsSection";

export default DealsSection;
